import PageHero from "../components/PageHero";
import SmartLink from "../components/SmartLink";
import { ArrowRightIcon } from "../components/Icons";

export default function NotFoundPage() {
  return (
    <>
      <PageHero
        eyebrow="404"
        title="We couldn't find that page"
        intro="The link may be out of date, or the page may have moved. Here are the places most people are heading."
      />

      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {[
              { label: "Product features", href: "/#features" },
              { label: "Pricing", href: "/pricing" },
              { label: "Documentation", href: "/docs" },
              { label: "Contact us", href: "/contact" },
            ].map((link) => (
              <SmartLink
                key={link.href}
                href={link.href}
                className="card flex items-center justify-between gap-3 p-5 text-sm font-semibold text-ink shadow-card transition-colors hover:border-brand-300 hover:text-brand-700"
              >
                {link.label}
                <ArrowRightIcon />
              </SmartLink>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
